import { render, staticRenderFns } from "./rechargeConfig.vue?vue&type=template&id=33cc1962&scoped=true&"
import script from "./rechargeConfig.vue?vue&type=script&lang=js&"
export * from "./rechargeConfig.vue?vue&type=script&lang=js&"
import style0 from "./rechargeConfig.vue?vue&type=style&index=0&id=33cc1962&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc1962",
  null
  
)

export default component.exports